// Shared list of Browse filter categories.
// Used by the /auctions route for dynamic head() metadata and by the sitemap
// generator to emit one entry per category page. Keep in sync with the
// category chips shown on the homepage.

export type BrowseCategory = {
  slug: string;      // URL-safe key (matches ?q= value, lowercased)
  q: string;         // The literal string passed to ?q=
  label: string;     // Display name
  title: string;     // <title> for the filtered page
  description: string; // <meta description>
};

const D = "Buy and sell graded and raw {name} through secure UK live auctions on BidNova Auctions. Bid in GBP with Stripe-secured payments, verified sellers and full buyer protection.";

function desc(name: string) {
  return D.replace("{name}", name);
}

export const BROWSE_CATEGORIES: BrowseCategory[] = [
  { slug: "pokemon", q: "pokemon", label: "Pokémon",
    title: "Pokémon Card Auctions UK | Graded & Raw | BidNova Auctions",
    description: desc("Pokémon cards") },
  { slug: "one-piece", q: "one piece", label: "One Piece",
    title: "One Piece Card Game Auctions UK | BidNova Auctions",
    description: desc("One Piece Card Game singles and sealed") },
  { slug: "yu-gi-oh", q: "yu-gi-oh", label: "Yu-Gi-Oh!",
    title: "Yu-Gi-Oh! Card Auctions UK | Graded & Vintage | BidNova Auctions",
    description: desc("Yu-Gi-Oh! trading cards") },
  { slug: "magic", q: "magic the gathering", label: "Magic: The Gathering",
    title: "Magic: The Gathering Auctions UK | MTG Singles | BidNova Auctions",
    description: desc("Magic: The Gathering singles and sealed product") },
  { slug: "dragon-ball", q: "dragon ball", label: "Dragon Ball Super",
    title: "Dragon Ball Super Card Auctions UK | BidNova Auctions",
    description: desc("Dragon Ball Super Card Game cards") },
  { slug: "gundam", q: "gundam", label: "Gundam",
    title: "Gundam Card Game Auctions UK | BidNova Auctions",
    description: desc("Gundam Card Game cards") },
  { slug: "sports", q: "sports", label: "Sports Cards",
    title: "Sports Card Auctions UK | Football, Basketball, Baseball | BidNova Auctions",
    description: desc("football, basketball, baseball and other sports cards") },
  { slug: "topps", q: "topps", label: "Topps",
    title: "Topps Card Auctions UK | Vintage & Modern | BidNova Auctions",
    description: desc("Topps trading cards") },
  { slug: "lorcana", q: "lorcana", label: "Disney Lorcana",
    title: "Disney Lorcana Card Auctions UK | BidNova Auctions",
    description: desc("Disney Lorcana trading cards") },
  { slug: "marvel", q: "marvel", label: "Marvel",
    title: "Marvel Trading Card Auctions UK | BidNova Auctions",
    description: desc("Marvel trading cards") },
  { slug: "star-wars", q: "star wars", label: "Star Wars Unlimited",
    title: "Star Wars Unlimited Card Auctions UK | BidNova Auctions",
    description: desc("Star Wars Unlimited cards") },
  { slug: "football", q: "football", label: "Football Cards",
    title: "Football Card Auctions UK | Panini, Topps, Prizm | BidNova Auctions",
    description: desc("football trading cards") },
  { slug: "basketball", q: "basketball", label: "Basketball Cards",
    title: "Basketball Card Auctions UK | Prizm, Select, Panini | BidNova Auctions",
    description: desc("basketball trading cards") },
  { slug: "baseball", q: "baseball", label: "Baseball Cards",
    title: "Baseball Card Auctions UK | Topps, Bowman | BidNova Auctions",
    description: desc("baseball trading cards") },
  { slug: "formula-1", q: "formula 1", label: "Formula 1",
    title: "Formula 1 Card Auctions UK | BidNova Auctions",
    description: desc("Formula 1 trading cards") },
  { slug: "ufc", q: "ufc", label: "UFC Cards",
    title: "UFC Card Auctions UK | Panini Prizm & More | BidNova Auctions",
    description: desc("UFC trading cards") },
  { slug: "digimon", q: "digimon", label: "Digimon",
    title: "Digimon Card Auctions UK | BidNova Auctions",
    description: desc("Digimon Card Game cards") },
  { slug: "weiss-schwarz", q: "weiss schwarz", label: "Weiss Schwarz",
    title: "Weiss Schwarz Card Auctions UK | BidNova Auctions",
    description: desc("Weiss Schwarz cards") },
  { slug: "flesh-and-blood", q: "flesh and blood", label: "Flesh and Blood",
    title: "Flesh and Blood Card Auctions UK | BidNova Auctions",
    description: desc("Flesh and Blood TCG cards") },
  { slug: "union-arena", q: "union arena", label: "Union Arena",
    title: "Union Arena Card Auctions UK | BidNova Auctions",
    description: desc("Union Arena cards") },
];

/** Look up a category by the raw `q` search-param value (case-insensitive). */
export function findCategoryByQ(q: string | undefined | null): BrowseCategory | null {
  if (!q) return null;
  const norm = q.trim().toLowerCase();
  if (!norm) return null;
  return (
    BROWSE_CATEGORIES.find((c) => c.q.toLowerCase() === norm) ??
    BROWSE_CATEGORIES.find((c) => c.label.toLowerCase() === norm) ??
    null
  );
}
